import React from "react";
import FocusLock from "react-focus-lock";
import { useIntl } from "react-intl";
import {
  CloseIcon,
  RotatePhone,
} from "@learningblocks/shared-components/lib/Icons";
import { FormattedMessage } from "@learningblocks/shared-components/lib/FormattedMessage";
import className from "../style.module.scss";

type RotateOverlayProps = {
  setOrientationPromptDismissed: (value: boolean) => void;
  setShowOrientationPrompt: (value: boolean) => void;
};

export function RotateOverlay({
  setOrientationPromptDismissed,
  setShowOrientationPrompt,
}: RotateOverlayProps) {
  const intl = useIntl();
  return (
    <FocusLock>
      <div className={className.orientationOverlay}>
        <img src={RotatePhone} alt="" />
        <p>
          {FormattedMessage({
            string: "Try rotating your device for the best experience!",
          })}
        </p>
        <button
          tabIndex={0}
          aria-label={intl.formatMessage({
            id: "Dismiss",
            defaultMessage: "Dismiss",
          })}
          onClick={() => {
            sessionStorage.setItem("orientationPromptDismissed", "true");
            setOrientationPromptDismissed(true);
            setShowOrientationPrompt(false);
          }}
        >
          <img src={CloseIcon} alt="" />
        </button>
      </div>
    </FocusLock>
  );
}
